export default __webpack_public_path__ + "static/media/Kaggle_logo.2b4bd2a7.png";